export default __webpack_public_path__ + "static/media/codio.228698d2.svg";